import Grid from "@mui/material/Grid2";
import ResearchReportTable from "./ResearchReportTable";
import GoodPracticeGuide from "./GoodPracticeGuide";

export default function Library() {

    return (
        <Grid container>
            <Grid size={6}>
                <GoodPracticeGuide folder={"NewSites"} />
            </Grid>
            <Grid size={6}>
                <GoodPracticeGuide folder={"GoodPracticeGuide"} />
            </Grid>
            <Grid size={6}>
                <ResearchReportTable tableType={"MiscReports"} title="Miscellaneous Reports"/>
            </Grid>
            <Grid size={6}>
                <ResearchReportTable tableType={"Research"} title="Research Reports" />
            </Grid>
        </Grid>
    );
}
